<template>
    <div class="page-wrapper">
        <div id="profile_content"
            class="page-content"
            v-if="isLoaded">
            <TopBarProfile
                :title="lbl.profile.page_title"
                @clickBack="clickBack()" />
            <div id="profile_top_section" class="profile-section">
                <div id="profile_top_section_wrapper">
                    <div id="profile_row">
                        <div id="profile_portrait">
                            <img id="profile_portrait_img" :src="lineImgUrl" />
                            <img id="profile_protrait_bar" src="../../../assets/other/portrait-naos.svg" />
                        </div>
                        <div id="profile_info">
                            <div id="profile_name">{{`${profile.firstName} ${profile.lastName}`}}</div>
                            <div id="profile_point">
                                <div id="profile_point_lbl">
                                    {{lbl.profile.have_point}}<span class="red-txt">{{$store.getters.getFormatted}}</span>
                                </div>
                                <img id="profile_point_ic" src="../../../assets/icon/reward_icon_coin@3x.png" />
                            </div>
                        </div>
                    </div>
                    <div id="profile_expired_point">
                        {{expiredMsg}}
                    </div>
                    <div id="profile_list">
                        <div class="profile-info-row">
                            <div class="profile-info-ic">
                                <img src="../../../assets/icon/profile-icon-phone.svg" >
                            </div>
                            <div class="profile-info-txt">{{contact_number}}</div>
                        </div>
                        <div class="profile-info-row">
                            <div class="profile-info-ic">
                                <img src="../../../assets/icon/profile-icon-bd.svg" >
                            </div>
                            <div class="profile-info-txt">{{birthdate}}</div>
                        </div>
                        <div class="profile-info-row">
                            <div class="profile-info-ic">
                                <img src="../../../assets/icon/profile-icon-email.svg" >
                            </div>
                            <div class="profile-info-txt">{{email}}</div>
                        </div>
                        <div class="profile-info-row">
                            <div id="profile_address_ic" class="profile-info-ic">
                                <img src="../../../assets/icon/profile-icon-address.svg" >
                            </div>
                            <div class="profile-info-txt">{{address}}</div>
                        </div>
                    </div>
                    <router-link to="/profile/edit" id="profile_edit_btn">{{lbl.profile.edit_profile_btn}}</router-link>
                </div>
            </div>
            <div id="profile_middle_section-wrapper">
                <div id="profile_middle_section" @click="clickMenuProfile()">
                    <div class="text-area">{{lbl.profile.user_consent}}</div>
                    <img class="ic-area" src="@/assets/icon/navbar_icon_back.svg">
                </div>
                <div id="profile_bottom_content">
                    <div id="profile_bottom_unsubscribe" @click="clickCancelMember()">{{lbl.profile.unsubscribe}}</div>
                    <div class="text-unsubscribe" v-html="lbl.profile.text_unsubscribe"></div>
                    <div id="bzbs_logo"><img src="../../../assets/bzbslogo/bzbs-new-logo.svg" /></div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController" />
        <FooterMenu
            currentMenu="profile"
            :controller="modalController">
        </FooterMenu>
    </div>
</template>
<script>
//helper
import AddressHelper from '@/helper/AddressHelper.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
import Util from '@/helper/Utility.js';
import CacheHelper from "@/helper/CacheHelper.js";
import Account from "@/helper/AccountHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//component
import TopBarProfile from '@/components/Layout/TopBarPage/TopBarProfile.vue';
import FooterMenu from '@/components/Layout/FooterMenu/FooterMenu.vue';
//core
import MemberApi from '@/core/Bioderma/service/MemberApi.js';
import { window } from 'rxjs/operators';
export default {
    name: 'Profile',
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin, ModalMixin],
    components: {
        TopBarProfile,
        FooterMenu,
    },
    data: function () {
        return {
            address: '',
            birthdate: '',
            contact_number: '',
            email: '',

            lineImgUrl: '',
            expiredMsg: '',
            isLoaded: false,
            lblmodal: null,
            tracking: new TrackingService(this)
        };
    },
    created: function(){
        this.lblmodal = this.lbl.profile.unsubscribe_modal;
        let cache = new CacheHelper('session');
        let isReload = cache.getCache('isReload');
        if (isReload) { // get profile อีกครั้งหลังจาก edit profile
            cache.removeCache('isReload');
            this.$nextTick(() => {
                location.reload();
            });
        }
    },
    methods: {
        //event
        clickBack: function () {
            var cache = new CacheHelper('session');
            if(cache.getCache('isFromEditProfile')){
                cache.removeCache('isFromEditProfile');
                this.$router.go(-3);
            }else{
                this.$router.back();
            }
        },
        //mixin
        accountInitiated: function () {
            if (!this.isLogin)
                window.location.replace('/login');

            let cacheAddress = this.getProfileAddress();
            let address = AddressHelper.getFullAddress(cacheAddress);

            this.address = address ? address : '-';
            this.birthdate = this.profile.birthDate ? DatetimeHelper.dateFullFormatNoUtc(this.profile.birthDate): '-';
            this.contact_number = Util.contactNumberFormat(this.profile.contactNumber, '-');
            this.email = this.profile.email ? this.profile.email : '-';

            this.lineImgUrl = this.getPictureLine();
            this.initialExpiredPoint();
        },
        setupModalCompleted: function(){
            this.initialOtherModal();
        },
        //method
        initialExpiredPoint: function () {
            this.getExpiringPoint()
                .then(data => {
                    let point =  Util.formatNum(data.expiring_points.points);
                    let expireDate =  DatetimeHelper.dateShortFormat(data.expiring_points.time);
                    this.expiredMsg = Util.stringFormat(this.lbl.main.text_expire_point, point, expireDate);
                    this.isLoaded = true;
                });
        },
        clickMenuProfile: function() {
            this.privacySettingModal
                            .setProfile(this.profile)
                            .show();
        },
        clickCancelMember: function(){
            this.tracking.screenName('Inactive_Page');
            this.tracking.event('inactive_account', 'click_inactive_account');
            this.cancelMemberModal
                .clearText()
                .setTag('cancel-member')
                .setTitle(this.lblmodal.title)
                .setMsg(this.lblmodal.msg)
                .setBtnOk(this.lblmodal.btn_confirm)
                .show()

            this.cancelMemberModal.onClickOk((data) => {
                if(data.tag == 'cancel-member'){
                    var token = this.getToken();
                    this.loadingModal.show();

                    MemberApi.apiDeactivate(token).subscribe((res) => {
                        console.log("res", res);
                        this.tracking.event('confirm_inactive_account', 'click_confirm_inactive_account');
                        this.loadingModal.hide();
                        this.alertModal
                            .clearText()
                            .setTitle(this.lblmodal.title)
                            .setMsg(this.lblmodal.msg_success)
                            .setBtnOk(this.lblmodal.btn_close)
                            .setTheme('gray')
                            .setTag('alert-cancel-member')
                            .show();

                        Account.setLogout();

                        this.alertModal.onClickOk((data) => {
                            if(data.tag == 'alert-cancel-member'){
                               this.$router.push('/');
                            }
                        });

                    },(error) =>{
                        this.loadingModal.hide();
                        this.errorApi(error);
                    });
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "../style/Profile.scss";
</style>
